window.addEventListener('load', function() {

  function updateColorVariantCount(element) {
      if (!element.hasAttribute('data-count-updated')) {
          element.setAttribute('data-count-updated', 'true'); // Mark to prevent duplicate processing
          const value = element.textContent || "";
          const colorCount = value.split('|').length;
          if (colorCount > 1){
              element.textContent = `Colors +${colorCount - 1}`;
              element.style.opacity = 1;
          } else {
              element.textContent = '';
          }
      }
  }

  function initializeFlickity(nostoList) {
      if (nostoList && !Flickity.data(nostoList)) {
          setTimeout(() => {
            const index = Array.from(document.querySelectorAll('.nosto-list')).indexOf(nostoList);
            const uniqueClassName = 'nosto-list-' + index;
            nostoList.classList.add(uniqueClassName);
            nostoList.style.display = 'block';
            new Flickity('.' + uniqueClassName, {
                cellAlign: 'left',
                contain: true,
                prevNextButtons: true
            });
            console.log("init sldr for", uniqueClassName);
          }, 200);
      }
  }

  function handleNostoListMutations(mutationsList, observer) {
      mutationsList.forEach(mutation => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
              mutation.addedNodes.forEach(node => {
                  if (node.matches && node.matches('.nosto-list')) {
                      initializeFlickity(node);
                      node.querySelectorAll('.nosto-list-item .colorVariantCount').forEach(updateColorVariantCount);
                  } else if (node.querySelectorAll) {
                      node.querySelectorAll('.nosto-list').forEach(initializeFlickity);
                      node.querySelectorAll('.nosto-list-item .colorVariantCount').forEach(updateColorVariantCount);
                  }
              });
          }
      });
  }

  const nostoObserver = new MutationObserver(handleNostoListMutations);
  const nostoListContainer = document.body; // Or a more specific parent if you know it

  nostoObserver.observe(nostoListContainer, { childList: true, subtree: true });

  function wrapDivsWithAnchor() {
      const nostoContainers = document.querySelectorAll('.nosto-image-container');
      nostoContainers.forEach(container => {
          const productUrl = container.getAttribute('product-url');
          const anchor = document.createElement('a');
          anchor.setAttribute('href', productUrl);
          container.parentNode.insertBefore(anchor, container);
          anchor.appendChild(container);
      });
  }

  function handleWishListClick(evt) {
      evt.stopPropagation();
      evt.preventDefault();
      const wishList = evt.target;
      const product = wishList.closest('.nosto-list-item');
      const wishlistbtn = wishList.closest('.wishlist');

      if (!product) return;

      const wishListObject = {
          "epi": product.getAttribute('data-variant-id'),
          "du": product.getAttribute('data-product-url'),
          "empi": product.getAttribute('data-product-id'),
          "iu": product.getAttribute('data-product-image-url')
      };

      const isSaved = wishList.classList.toggle('is-saved');
      const iconswitch = wishlistbtn.classList.toggle('is-saved');
      const action = isSaved ? 'addToWishList' : 'removeFromWishList';

      window._swat[action](wishListObject, function(r) {
          console.log('wishlist', isSaved ? 'added' : 'removed', r);
          theme.updateWishList();
      });
  }

  function initializeWishlistButtons() {
      const wishlistButtons = document.querySelectorAll('.wishlist');
      wishlistButtons.forEach(function(button) {
          if (!button.getAttribute('data-wishlist-initialized')) {
              const empi = button.getAttribute('data-empi');
              const epi = button.getAttribute('data-epi');
              if (empi || epi) {
                const matching_arr = window.myWishList ? window.myWishList.filter(i => i.empi == empi || i.epi == epi) : [];
                if (matching_arr.length) button.classList.add('is-saved');
              }
              button.addEventListener('click', handleWishListClick);
              button.setAttribute('data-wishlist-initialized', 'true');
          }
      });
  }

  function observeWishlistButtons(container = document) {
      const wishlistObserver = new MutationObserver((mutationsList, observer) => {
          mutationsList.forEach(mutation => {
              if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                  mutation.addedNodes.forEach(node => {
                      if (node.matches && node.matches('.wishlist')) {
                          initializeWishlistButtons();
                      } else if (node.querySelectorAll) {
                          node.querySelectorAll('.wishlist').forEach(initializeWishlistButtons);
                      }
                  });
              }
          });
      });

      wishlistObserver.observe(container, { childList: true, subtree: true });
      initializeWishlistButtons(); // Initial check for existing buttons
  }

  function initializeCartDrawerATC() {
      const nostoCartElements = document.querySelectorAll('.nosto-cart-el');
      nostoCartElements.forEach(nostoCartElement => {
          const upsellProductItems = nostoCartElement.querySelectorAll('.nosto-list-item');
          upsellProductItems.forEach(upsellProduct => {
              const upsellAddToCartButton = upsellProduct.querySelector('.atc-cart-nosto');
              if (upsellAddToCartButton && !upsellAddToCartButton.getAttribute('data-atc-initialized')) {
                  upsellAddToCartButton.addEventListener('click', function (event) {
                      if (upsellAddToCartButton.classList.contains('already-in-cart')) {
                          const cartDrawerButton = document.querySelector(".js-drawer-open-cart");
                          if (cartDrawerButton) {
                              cartDrawerButton.click();
                          }
                      }
                      event.stopPropagation();
                      event.preventDefault();
                      theme.SizeDrawer.open(event, upsellProduct.getAttribute('data-product-handle'));
                  });
                  upsellAddToCartButton.setAttribute('data-atc-initialized', 'true');
              }
          });
      });
  }

  function observeCartDrawer(cartDrawer) {
      if (!cartDrawer) return;
      const cartObserver = new MutationObserver((mutationsList, observer) => {
          mutationsList.forEach(mutation => {
              if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                  mutation.addedNodes.forEach(node => {
                      if (node.matches && node.matches('.nosto-cart-el')) {
                          initializeCartDrawerATC();
                      } else if (node.querySelectorAll) {
                          node.querySelectorAll('.nosto-cart-el').forEach(initializeCartDrawerATC);
                      }
                  });
              }
          });
      });
      cartObserver.observe(cartDrawer, { childList: true, subtree: true });
      initializeCartDrawerATC(); // Initial check
  }

  // function initializeSliderWhenDrawerIsOpen(cartDrawer) {
  //     if (!cartDrawer) return;
  //     const isOpen = cartDrawer.classList.contains('drawer--is-open');

  //     document.querySelectorAll(".nosto-cart-el .nosto-list").forEach(slider => {
  //         if (slider) {
  //             let existingFlkty = Flickity.data(slider);
  //             if (isOpen && !existingFlkty) {
  //                 new Flickity(slider, {
  //                     cellAlign: 'left',
  //                     contain: true,
  //                     pageDots: false,
  //                     prevNextButtons: false
  //                 });
  //                 console.log("init cart sldr");
  //               setTimeout(() => { initializeCartDrawerATC(); }, 1000);
  //             } else if (!isOpen && existingFlkty) {
  //                 existingFlkty.destroy();
  //                 console.log("destroy cart sldr");
  //             }
  //         }
  //     });
  // }

  function observeCartDrawerForSlider(cartDrawer) {
      if (!cartDrawer) return;
      const observer = new MutationObserver((mutationsList, observer) => {
          mutationsList.forEach(mutation => {
              if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                  // initializeSliderWhenDrawerIsOpen(cartDrawer);
              } else if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                  mutation.addedNodes.forEach(node => {
                      if (node.matches && node.matches('.nosto-cart-el .nosto-list')) {
                          // initializeSliderWhenDrawerIsOpen(cartDrawer);
                        initializeCartDrawerATC();
                      } else if (node.querySelectorAll) {
                          // node.querySelectorAll('.nosto-cart-el .nosto-list').forEach(slider => initializeSliderWhenDrawerIsOpen(cartDrawer));
                        initializeCartDrawerATC();
                      }
                  });
              }
          });
      });

      observer.observe(cartDrawer, { attributes: true, childList: true, subtree: true });
      // initializeSliderWhenDrawerIsOpen(cartDrawer); // Initial check
  }

  wrapDivsWithAnchor();
  const cartDrawer = document.getElementById('CartDrawer');
  observeCartDrawer(cartDrawer);
  observeCartDrawerForSlider(cartDrawer);
  observeWishlistButtons();

  const ccartButton = document.querySelector(".js-drawer-open-cart");
  if (ccartButton) {
      ccartButton.addEventListener('click', function() {
        theme.cart.getCart().then((cart) => {
          document.getElementById('cart-item-count').textContent = cart.item_count;
        });
        // initializeSliderWhenDrawerIsOpen(cartDrawer); // Already handled by observer
      });
  }
});